import { gql } from '@apollo/client';

export const GET_ADMIN_ROSTER_DATA = gql`
  query GetAdminRosterData($seasonId: Int) {
    players(where: { lastSeason: { _eq: $seasonId } }) {
      id
      lastName
      firstName
      lastSeason
      position
      positionSecondary
      rosters(where: { team: { season: { _eq: $seasonId } } }) {
        teamId
      }
    }
    teams(where: { season: { _eq: $seasonId } }) {
      name
      id
    }
  }
`;
